import React, { useEffect } from "react";
import { theme } from "antd";

export const CircleAnimation = () => {
	const { token: antToken } = theme.useToken();
	useEffect(() => {
		const fadeOutCircles = () => {
			const circles = document.querySelector("#circles");
			if (circles) {
				circles.classList.add("fade-out");
				setTimeout(() => {
					if (circles) {
						circles.style.display = "none";
					}
				}, 20000);
			}
		};

		setTimeout(fadeOutCircles, 40000);
	}, []);

	return (
		<div id="circles" style={{...styles.circlesContainer, backgroundColor: antToken.colorBgLayout}}>
			<div style={styles.circles}>
				<div style={{ ...styles.circle, ...styles.verySmall }}></div>
				<div style={{ ...styles.circle, ...styles.small }}></div>
				<div style={{ ...styles.circle, ...styles.medium }}></div>
				<div style={{ ...styles.circle, ...styles.big }}></div>
				<div style={{ ...styles.circle, ...styles.medium }}></div>
				<div style={{ ...styles.circle, ...styles.small }}></div>
				<div style={{ ...styles.circle, ...styles.verySmall }}></div>
			</div>
		</div>
	);
};

const styles = {
	circlesContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100vh",
		width: "100vw",
		position: "fixed",
		top: 0,
		left: 0,
		zIndex: 9999, // Asegurarse de que esté encima de todo
	},
	circles: {
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
	},
	circle: {
		marginLeft: "5px",
		borderRadius: "100%",
		animationDuration: "1.2s",
		animationName: "circlePulse",
		animationIterationCount: "infinite",
	},
	verySmall: {
		height: "10px",
		width: "10px",
		animationDelay: ".9s",
		backgroundColor: "#2d5db7",
	},
	small: {
		height: "20px",
		width: "20px",
		animationDelay: ".6s",
		backgroundColor: "#2d5db7",
	},
	medium: {
		height: "30px",
		width: "30px",
		animationDelay: ".3s",
		backgroundColor: "#2d5db7",
	},
	big: {
		height: "40px",
		width: "40px",
		backgroundColor: "#2d5db7",
	},
	"@keyframes circlePulse": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.5 },
	},
	".fade-out": {
		animation: "fadeOut 2s forwards",
	},
	"@keyframes fadeOut": {
		"0%": { opacity: 1 },
		"100%": { opacity: 0 },
	},
};

export const CircleAnimationCompact = () => {
	useEffect(() => {
		const fadeOutCircles = () => {
			const circles = document.querySelector("#compact-circles");
			if (circles) {
				circles.classList.add("fade-out");
				setTimeout(() => {
					if (circles) {
						circles.style.display = "none";
					}
				}, 20000);
			}
		};

		setTimeout(fadeOutCircles, 40000);
	}, []);

	return (
		<div
			id="compact-circles"
			style={{
				...stylesCompact.circlesContainer,
				//...(fullScreen ? stylesCompact.fullScreen : stylesCompact.inlineContainer),
			}}
		>
			<div style={stylesCompact.circles}>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.verySmall }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.small }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.medium }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.big }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.medium }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.small }}></div>
				<div style={{ ...stylesCompact.circle, ...stylesCompact.verySmall }}></div>
			</div>
		</div>
	);
};

const stylesCompact = {
	circlesContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "100%",
		width: "100%",
		zIndex: 9999, // Asegurarse de que esté encima de todo
	},
	fullScreen: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100vw",
		height: "100vh",
	},
	inlineContainer: {
		position: "relative",
		width: "100%",
		height: "100%",
	},
	circles: {
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
	},
	circle: {
		marginLeft: "5px",
		borderRadius: "100%",
		animationDuration: "1.2s",
		animationName: "circlePulse",
		animationIterationCount: "infinite",
	},
	verySmall: {
		height: "10px",
		width: "10px",
		animationDelay: ".9s",
		backgroundColor: "#2d5db7",
	},
	small: {
		height: "20px",
		width: "20px",
		animationDelay: ".6s",
		backgroundColor: "#2d5db7",
	},
	medium: {
		height: "30px",
		width: "30px",
		animationDelay: ".3s",
		backgroundColor: "#2d5db7",
	},
	big: {
		height: "40px",
		width: "40px",
		backgroundColor: "#2d5db7",
	},
	"@keyframes circlePulse": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.5 },
	},
	".fade-out": {
		animation: "fadeOut 2s forwards",
	},
	"@keyframes fadeOut": {
		"0%": { opacity: 1 },
		"100%": { opacity: 0 },
	},
};
